// extracted by mini-css-extract-plugin
export var placeholder = "youtube-module--placeholder--gzjNQ";
export var button = "youtube-module--button--IE3aL";
export var wrapper = "youtube-module--wrapper--cnzWg";
export var fadein = "youtube-module--fadein--X0zC0";